import { useCallback } from 'react';
import { useRouter } from 'next/router';

import { isAuthenticationError, isCanceledError } from '@/api/apiUtil';
import { useUserLocalStorageState } from '@/lib/auth/hooks/useUserLocalStorageState';
import { clearUserSession } from '@/lib/auth/userStorage';
import { combinePathAndQuery } from '@/utils/combinePathAndQuery';

export const useApiError = () => {
  const router = useRouter();
  const { clearUser } = useUserLocalStorageState();

  const goLoginPage = useCallback(async () => {
    clearUserSession();
    clearUser();
    if (router.isReady && router.asPath) {
      if (!router.query['callbackUrl'] && router.asPath !== '/login') {
        router.query['callbackUrl'] = router.asPath;
      }
      await router.push(combinePathAndQuery('/login', router.query));
    }
  }, [clearUser, router]);

  return (error: Error) => {
    if (isCanceledError(error)) {
      return;
    }

    if (isAuthenticationError(error)) {
      void goLoginPage();
    }
  };
};
